// @flow

import styled from 'styled-components';
import {
  Grid,
  Button,
  MEDIA,
  COLORS,
  FONT_WEIGHT,
  TYPE_SCALE,
  SPACING,
  LINE_HEIGHT,
} from 'clark-styles';

import Subject from 'assets/icons/subject.svg';

const { CLARK_PRIMARY, CLARK_SECONDARY, GREY_100, GREY_75, GREY_50 } = COLORS;
const { S_05, S_1, S_2, S_4 } = SPACING;
const { FW_100, FW_400, FW_700 } = FONT_WEIGHT;
const { TS_3, TS_5, TS_6 } = TYPE_SCALE;
const { TITLE, COPY } = LINE_HEIGHT;

const MODAL_WIDTH = '450px';

export const Wrapper = styled.div`
  width: ${MODAL_WIDTH};
  padding: ${S_2} ${S_4};
`;

export const Header = styled.h1`
  ${FW_400};
  ${TS_3};
  ${TITLE};
  color: ${GREY_100};
  margin: 0 0 ${S_1} 0;
`;

export const InfoItem = styled.div`
  ${FW_100};
  align-items: center;
  display: flex;
  color: ${GREY_75};
  margin-bottom: ${S_2};
`;

// $FlowFixMe
export const SubjectIcon = styled<any>(Subject)`
  color: ${CLARK_SECONDARY};
`;

export const InfoCopy = styled.span`
  ${FW_400};
  margin: 0 ${S_05};
`;

export const Headline = styled.h1`
  ${TS_3};
  ${FW_700};
  ${TITLE};
  color: ${GREY_100};
  margin: 0;
`;

export const Copy = styled.p`
  ${TS_6};
  ${FW_100};
  ${COPY};
  color: ${GREY_50};
  margin: ${S_05} 0;
`;

export const SubmitButton = styled<any>(Button)`
  margin: ${S_1} 0;
`;

export const Cta = styled.button`
  ${TS_6};
  ${FW_700};
  ${COPY};
  border: none;
  background: transparent;
  color: ${CLARK_PRIMARY};
  display: block;
  text-decoration: none;
  padding: 0;
  margin: ${S_2} auto;
  cursor: pointer;
  text-transform: uppercase;

  &:focus {
    outline: 0;
  }
`;

export const GridWrapper = styled<any>(Grid)`
  margin-top: ${S_2};

  ${MEDIA.medium`
    margin-top: ${S_4};
  `};
`;
export const RecurringSessionsContainer = styled.div`
  margin-bottom: ${S_2};
`;

export const RecurringSessionsHeader = styled.div`
  ${FW_700};
  ${TS_5};
  ${COPY};
  color: ${GREY_100};
  margin: 0 0 ${S_1} 0;
`;

export const Item = styled.li`
  ${FW_100};
  color: ${GREY_100};
  margin: 0 0 ${S_1} 0;
`;



// WEBPACK FOOTER //
// ./src/containers/sessions/edit-form/styles.js